<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2>Archive Caster сервера</h2>
        <search :query.sync="query" @search="search" />
        <el-table ref="table" :data="items">
          <el-table-column label="Название сервера">
            <template slot-scope="scope">
              <span class="link" @click="openEdit(scope.row)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Действия" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="small"
                :disabled="!$can('delete', 'archive_casters')"
                @click="deleteItem(scope.row.id_archive_caster)"
              >
                Удалить
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="list__pagination"
          layout="prev, pager, next"
          :page-size="count"
          :total="total"
          :current-page="page"
          @current-change="changePage"
        />
      </div>
      <el-dialog :title="editId ? 'Редактирование' : 'Добавление'" :visible.sync="visible" @close="close">
        <el-input placeholder="Название сервера" size="small" v-model="name" />
        <span slot="footer">
          <el-button v-if="canSubmit" type="primary" size="small" @click="submit">
            {{ editId ? "Сохранить" : "Добавить" }}
          </el-button>
        </span>
      </el-dialog>
    </main>
    <el-footer class="page__active_bar">
      <el-button
        v-if="$can('create', 'archive_casters')"
        class="page__active_button"
        icon="el-icon-plus"
        type="primary"
        @click="openCreate"
      >
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import routeList from "@/core/mixins/routeList";
import Search from "@/components/Search";

export default {
  name: "ArchiveCastersList",
  components: {
    Search,
  },
  mixins: [routeList],
  data() {
    return {
      query: "",
      visible: false,
      name: "",
      editId: null,
    };
  },
  computed: {
    ...mapState("archiveCasters", {
      items: (state) => state.archiveCasters.data,
      total: (state) => state.archiveCasters.total,
      count: (state) => state.archiveCasters.count,
    }),
    ...mapGetters("archiveCasters", ["getQuery"]),
    canSubmit() {
      return this.editId
        ? this.$can("update", "archive_casters")
        : this.$can("create", "archive_casters");
    },
  },
  methods: {
    ...mapActions("archiveCasters", {
      getList: "GET_ARCHIVE_CASTERS",
      addItem: "ADD_ARCHIVE_CASTER",
      updateItem: "UPDATE_ARCHIVE_CASTER",
      removeItem: "REMOVE_ARCHIVE_CASTER",
    }),
    ...mapMutations("archiveCasters", {
      setQuery: "SET_QUERY",
    }),
    openCreate() {
      this.editId = null;
      this.name = "";
      this.visible = true;
    },
    openEdit(row) {
      this.editId = row.id_archive_caster;
      this.name = row.name;
      this.visible = true;
    },
    submit() {
      const action = this.editId
        ? this.updateItem({ id: this.editId, newArchiveCaster: { name: this.name } })
        : this.addItem({ name: this.name });

      action
        .then(() => {
          this.visible = false;
          this.$message({
            message: this.editId ? "Изменения сохранены" : "Сервер добавлен",
            type: "success",
          });
          this.loadData();
        })
        .catch(({ response }) => {
          this.$message({
            message: response.data.error || "Неизвестная ошибка",
            type: "error",
          });
        });
    },
    deleteItem(id) {
      this.$confirm("Удалить Archive Caster сервер?", "Удаление", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        cancelButtonClass: "el-button--success",
        type: "warning",
      })
        .then(() => this.removeItem(id))
        .then(() => {
          this.$message({
            message: "Сервер удалён",
            type: "success",
          });
          this.loadData();
        })
        .catch((e) => {
          // Отмену в окне подтверждения Element UI передаёт сюда же строкой "cancel" — её не показываем.
          if (e === "cancel") return;
          this.$message({
            type: "error",
            message: (e.response && e.response.data.error) || "Неизвестная ошибка",
          });
        });
    },
    close() {
      this.name = "";
      this.editId = null;
    },
  },
};
</script>

<style scoped>
.link {
  cursor: pointer;
  color: #409eff;
}
</style>
